module.exports = __webpack_public_path__ + "img/co.ecd28ebe.png";